var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tasks-page"
  }, [_c('div', {
    staticClass: "tasks-main"
  }, [_c('div', {
    staticClass: "tasks-head"
  }, [_c('img', {
    attrs: {
      "src": require('@images/task-head.jpg'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "tasks__title"
  }, [_vm._v("Complete Tasks")]), _c('div', {
    staticClass: "tasks__sub"
  }, [_vm._v("Earn SEES and tickets daily")]), _c('div', {
    staticClass: "tasks-tab"
  }, [_c('m-tab', {
    attrs: {
      "tab": _vm.tabList,
      "selectTab": _vm.selectTab
    },
    on: {
      "update:selectTab": function ($event) {
        _vm.selectTab = $event;
      },
      "update:select-tab": function ($event) {
        _vm.selectTab = $event;
      }
    }
  })], 1), _vm.selectTab && _vm.selectTab.value == 0 ? _c('div', {
    staticClass: "tasks-list"
  }, [_vm.officialTaskList && _vm.officialTaskListFilter.length > 0 ? _c('div', {
    staticClass: "tasks-list__title"
  }, [_vm._v("BASE")]) : _vm._e(), _c('transition-group', {
    staticClass: "tasks-list-main",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, [_vm.officialTaskList ? _vm._l(_vm.officialTaskListFilter.slice(0, 4), function (item, index) {
    return _c('div', {
      key: `official${index}`,
      staticClass: "tasks-item",
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      },
      on: {
        "click": function ($event) {
          return _vm.onShowTaskPop(item);
        }
      }
    }, [_c('div', {
      staticClass: "tasks-item__img"
    }, [item.icon ? [_c('img', {
      attrs: {
        "src": item.icon
      }
    })] : item.type == 'discord' || item.type == 'telegram' || item.type == 'channel' || item.type == 'browser' ? [_c('img', {
      attrs: {
        "src": require(`@images/icon-${item.type == 'channel' ? 'telegram' : item.type}.png`),
        "alt": ""
      }
    })] : _vm._e()], 2), _c('div', {
      staticClass: "tasks-item-info"
    }, [_c('div', {
      staticClass: "tasks-item__title",
      class: _vm.isMobile && 'wap'
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "tasks-item-reward"
    }, [item.reward > 0 ? _c('i', [_c('img', {
      attrs: {
        "src": require(`@images/icon/icon-coin.png`),
        "alt": ""
      }
    }), _vm._v(" +" + _vm._s(_vm._f("fmt_pre")(item.reward)) + " ")]) : _vm._e(), item.reward_ticket > 0 ? _c('i', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v(" +" + _vm._s(_vm._f("fmt_pre")(item.reward_ticket)) + " ")]) : _vm._e()])]), _c('div', {
      staticClass: "tasks-btns"
    }, [_c('div', {
      staticClass: "tasks-arrow"
    }, [item.isLoading ? _c('div', {
      staticClass: "circleLoading"
    }) : item.completed === 1 ? _c('svg-icon', {
      staticClass: "ok",
      attrs: {
        "name": "icon-ok"
      }
    }) : _c('svg-icon', {
      attrs: {
        "name": "icon-arrow"
      }
    })], 1)])]);
  }) : _vm._e()], 2), !_vm.officialTaskList ? [_vm._m(0)] : _vm._e()], 2) : _vm._e(), _vm.selectTab && _vm.selectTab.value == 0 ? _c('div', {
    staticClass: "tasks-list"
  }, [_vm.extraTaskList && _vm.extraTaskListFilter.length > 0 ? _c('div', {
    staticClass: "tasks-list__title"
  }, [_vm._v("EXTARS")]) : _vm._e(), _c('transition-group', {
    staticClass: "tasks-list-main",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, [_vm.extraTaskList ? _vm._l(_vm.extraTaskListFilter, function (item, index) {
    return _c('div', {
      key: `extra${index}`,
      staticClass: "tasks-item",
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      },
      on: {
        "click": function ($event) {
          return _vm.onShowTaskPop(item);
        }
      }
    }, [_c('div', {
      staticClass: "tasks-item__img"
    }, [item.icon ? [_c('img', {
      attrs: {
        "src": item.icon
      }
    })] : item.type == 'discord' || item.type == 'telegram' || item.type == 'channel' || item.type == 'browser' ? [_c('img', {
      attrs: {
        "src": require(`@images/icon-${item.type == 'channel' ? 'telegram' : item.type}.png`),
        "alt": ""
      }
    })] : _vm._e()], 2), _c('div', {
      staticClass: "tasks-item-info"
    }, [_c('div', {
      staticClass: "tasks-item__title",
      class: _vm.isMobile && 'wap'
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "tasks-item-reward"
    }, [item.reward > 0 ? _c('i', [_c('img', {
      attrs: {
        "src": require(`@images/icon/icon-coin.png`),
        "alt": ""
      }
    }), _vm._v(" +" + _vm._s(_vm._f("fmt_pre")(item.reward)) + " ")]) : _vm._e(), item.reward_ticket > 0 ? _c('i', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v(" +" + _vm._s(_vm._f("fmt_pre")(item.reward_ticket)) + " ")]) : _vm._e()])]), _c('div', {
      staticClass: "tasks-btns"
    }, [_c('div', {
      staticClass: "tasks-arrow"
    }, [item.isLoading ? _c('div', {
      staticClass: "circleLoading"
    }) : item.completed === 1 ? _c('svg-icon', {
      staticClass: "ok",
      attrs: {
        "name": "icon-ok"
      }
    }) : _c('svg-icon', {
      attrs: {
        "name": "icon-arrow"
      }
    })], 1)])]);
  }) : _vm._e()], 2), !_vm.extraTaskList ? [_vm._m(1)] : _vm._e()], 2) : _vm._e(), _vm.selectTab && _vm.selectTab.value == 1 ? _c('div', {
    staticClass: "tasks-list"
  }, [_vm.oneTimeTaskList && _vm.oneTimeTaskFilter.length > 0 ? _c('div', {
    staticClass: "tasks-list__title"
  }, [_vm._v("Active")]) : _vm._e(), _c('transition-group', {
    staticClass: "tasks-list-main",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, [_vm.oneTimeTaskList ? _vm._l(_vm.oneTimeTaskFilter, function (item, index) {
    return _c('div', {
      key: `extra${index}`,
      staticClass: "tasks-item",
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      },
      on: {
        "click": function ($event) {
          return _vm.onShowTaskPop(item);
        }
      }
    }, [_c('div', {
      staticClass: "tasks-item__img"
    }, [item.icon ? [_c('img', {
      attrs: {
        "src": item.icon
      }
    })] : item.type == 'discord' || item.type == 'telegram' || item.type == 'channel' || item.type == 'browser' ? [_c('img', {
      attrs: {
        "src": require(`@images/icon-${item.type == 'channel' ? 'telegram' : item.type}.png`),
        "alt": ""
      }
    })] : _vm._e()], 2), _c('div', {
      staticClass: "tasks-item-info"
    }, [_c('div', {
      staticClass: "tasks-item__title",
      class: _vm.isMobile && 'wap'
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "tasks-item-reward"
    }, [item.reward > 0 ? _c('i', [_c('img', {
      attrs: {
        "src": require(`@images/icon/icon-coin.png`),
        "alt": ""
      }
    }), _vm._v(" +" + _vm._s(_vm._f("fmt_pre")(item.reward)) + " ")]) : _vm._e(), item.reward_ticket > 0 ? _c('i', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v(" +" + _vm._s(_vm._f("fmt_pre")(item.reward_ticket)) + " ")]) : _vm._e()])]), _c('div', {
      staticClass: "tasks-btns"
    }, [_c('div', {
      staticClass: "tasks-arrow"
    }, [item.isLoading ? _c('div', {
      staticClass: "circleLoading"
    }) : item.completed === 1 ? _c('svg-icon', {
      staticClass: "ok",
      attrs: {
        "name": "icon-ok"
      }
    }) : _c('svg-icon', {
      attrs: {
        "name": "icon-arrow"
      }
    })], 1)])]);
  }) : _vm._e()], 2), !_vm.oneTimeTaskList ? [_vm._m(2)] : _vm._e()], 2) : _vm._e(), _vm.selectTab && _vm.selectTab.value == 2 ? _c('div', {
    staticClass: "tasks-list"
  }, [_vm.dailyTaskList && _vm.dailyTaskFilter.length > 0 ? _c('div', {
    staticClass: "tasks-list__title"
  }, [_vm._v("Active")]) : _vm._e(), _c('transition-group', {
    staticClass: "tasks-list-main",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, [_vm.dailyTaskList ? _vm._l(_vm.dailyTaskFilter, function (item, index) {
    return _c('div', {
      key: `extra${index}`,
      staticClass: "tasks-item",
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      },
      on: {
        "click": function ($event) {
          return _vm.onShowTaskPop(item);
        }
      }
    }, [_c('div', {
      staticClass: "tasks-item__img"
    }, [item.icon ? [_c('img', {
      attrs: {
        "src": item.icon
      }
    })] : item.type == 'discord' || item.type == 'telegram' || item.type == 'channel' || item.type == 'browser' ? [_c('img', {
      attrs: {
        "src": require(`@images/icon-${item.type == 'channel' ? 'telegram' : item.type}.png`),
        "alt": ""
      }
    })] : _vm._e()], 2), _c('div', {
      staticClass: "tasks-item-info"
    }, [_c('div', {
      staticClass: "tasks-item__title",
      class: _vm.isMobile && 'wap'
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "tasks-item-reward"
    }, [item.reward > 0 ? _c('i', [_c('img', {
      attrs: {
        "src": require(`@images/icon/icon-coin.png`),
        "alt": ""
      }
    }), _vm._v(" +" + _vm._s(_vm._f("fmt_pre")(item.reward)) + " ")]) : _vm._e(), item.reward_ticket > 0 ? _c('i', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v(" +" + _vm._s(_vm._f("fmt_pre")(item.reward_ticket)) + " ")]) : _vm._e()])]), _c('div', {
      staticClass: "tasks-btns"
    }, [_c('div', {
      staticClass: "tasks-arrow"
    }, [item.isLoading ? _c('div', {
      staticClass: "circleLoading"
    }) : item.completed === 1 ? _c('svg-icon', {
      staticClass: "ok",
      attrs: {
        "name": "icon-ok"
      }
    }) : _c('svg-icon', {
      attrs: {
        "name": "icon-arrow"
      }
    })], 1)])]);
  }) : _vm._e()], 2), !_vm.dailyTaskList ? [_vm._m(3)] : _vm._e()], 2) : _vm._e(), _c('div', {
    staticClass: "tasks-list completed"
  }, [_vm.completedTaskList && _vm.completedTaskList.length > 0 ? _c('div', {
    staticClass: "tasks-list__title"
  }, [_vm._v("Completed")]) : _vm._e(), _c('transition-group', {
    staticClass: "tasks-list-main",
    attrs: {
      "tag": "div"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enterLongList
    }
  }, [_vm.completedTaskList ? _vm._l(_vm.completedTaskList, function (item, index) {
    return _c('div', {
      key: `extra${index}`,
      staticClass: "tasks-item",
      attrs: {
        "data-index": index <= 50 ? index + 1 : 0
      },
      on: {
        "click": function ($event) {
          return _vm.onShowTaskPop(item);
        }
      }
    }, [_c('div', {
      staticClass: "tasks-item__img"
    }, [item.icon ? [_c('img', {
      attrs: {
        "src": item.icon
      }
    })] : item.type == 'discord' || item.type == 'telegram' || item.type == 'channel' || item.type == 'browser' ? [_c('img', {
      attrs: {
        "src": require(`@images/icon-${item.type == 'channel' ? 'telegram' : item.type}.png`),
        "alt": ""
      }
    })] : _vm._e()], 2), _c('div', {
      staticClass: "tasks-item-info"
    }, [_c('div', {
      staticClass: "tasks-item__title",
      class: _vm.isMobile && 'wap'
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "tasks-item-reward"
    }, [item.reward > 0 ? _c('i', [_c('img', {
      attrs: {
        "src": require(`@images/icon/icon-coin.png`),
        "alt": ""
      }
    }), _vm._v(" +" + _vm._s(_vm._f("fmt_pre")(item.reward)) + " ")]) : _vm._e(), item.reward_ticket > 0 ? _c('i', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.svg_tickets)
      }
    }), _vm._v(" +" + _vm._s(_vm._f("fmt_pre")(item.reward_ticket)) + " ")]) : _vm._e()])]), _c('div', {
      staticClass: "tasks-btns"
    }, [_c('div', {
      staticClass: "tasks-arrow"
    }, [item.isLoading ? _c('div', {
      staticClass: "circleLoading"
    }) : item.completed === 1 ? _c('svg-icon', {
      staticClass: "ok",
      attrs: {
        "name": "icon-ok"
      }
    }) : _c('svg-icon', {
      attrs: {
        "name": "icon-arrow"
      }
    })], 1)])]);
  }) : _vm._e()], 2)], 1)]), _c('m-menu'), _c('pop-prompt', {
    attrs: {
      "location": "bottom",
      "className": "popTaskBox",
      "isShadowClick": true,
      "title": " ",
      "isSmallConfirmBtn": _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('isSmallConfirmBtn') && _vm.popPromptInfo.isSmallConfirmBtn,
      "isCancelLoading": _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('isCancelLoading') && _vm.popPromptInfo.isCancelLoading,
      "isSmallCancelBtn": _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('smallCancelBtn') && _vm.popPromptInfo.smallCancelBtn,
      "show": _vm.popPromptShow,
      "isConfirmLoading": _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('isConfirmLoading') && _vm.popPromptInfo.isConfirmLoading,
      "isBtnCancel": _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('cancelText') && _vm.popPromptInfo.cancelText != null,
      "content": "html",
      "cancelText": _vm.popPromptInfo ? _vm.popPromptInfo.cancelText : ' ',
      "confirmText": _vm.popPromptInfo ? _vm.popPromptInfo.confirmText : ' '
    },
    on: {
      "update:show": function ($event) {
        _vm.popPromptShow = $event;
      },
      "cancel": function ($event) {
        _vm.popPromptInfo && _vm.popPromptInfo.cancelText && _vm.popPromptInfo.hasOwnProperty('cancelFn') && _vm.popPromptInfo.cancelFn();
      },
      "confirm": function ($event) {
        _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('confirmFn') && _vm.popPromptInfo.confirmFn();
      }
    },
    scopedSlots: _vm._u([{
      key: "error",
      fn: function () {
        return [_vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('error') && _vm.popPromptInfo.error ? _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.popPromptInfo.error)
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "pop-task"
  }, [_vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('icon') && _vm.popPromptInfo.icon ? _c('div', {
    staticClass: "pop-task__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.popPromptInfo.icon,
      "alt": ""
    }
  })]) : _vm._e(), _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('title') && _vm.popPromptInfo.title ? _c('div', {
    staticClass: "pop-task__title"
  }, [_vm._v(_vm._s(_vm.popPromptInfo.title))]) : _vm._e(), _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('remarks') && _vm.popPromptInfo.remarks ? _c('div', {
    staticClass: "pop-task__sub",
    domProps: {
      "innerHTML": _vm._s(_vm.popPromptInfo.remarks)
    }
  }) : _vm._e(), _vm.popPromptInfo && _vm.popPromptInfo.hasOwnProperty('reward') && _vm.popPromptInfo.reward ? _c('div', {
    staticClass: "pop-task-reward",
    domProps: {
      "innerHTML": _vm._s(_vm.popPromptInfo.reward)
    }
  }) : _vm._e()])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tasks-list__title"
  }, [_vm._v(" BASE "), _c('div', {
    staticClass: "circleLoading"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tasks-list__title"
  }, [_vm._v(" EXTARS "), _c('div', {
    staticClass: "circleLoading"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tasks-list__title"
  }, [_vm._v(" Active "), _c('div', {
    staticClass: "circleLoading"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tasks-list__title"
  }, [_vm._v(" Active "), _c('div', {
    staticClass: "circleLoading"
  })]);
}];
export { render, staticRenderFns };